import React, { useState, useEffect, useContext } from "react";
import { Helmet } from "react-helmet-async";
import { Container } from "react-bootstrap";

import Clients from "./Clients";

import { useDispatch, useSelector } from "react-redux";
import { getSubaccounts } from "../../redux/slices/subaccounts";
import Loader from "../../components/spinners/Loader";
import NotyfContext from "../../contexts/NotyfContext";
import { useWhitelabel } from "../../contexts/WhitelabelContext";

const Subaccounts = () => {
  const dispatch = useDispatch();
  const { subaccounts } = useSelector((state) => state.subaccounts);
  const { user } = useSelector((state) => state.user);
  const { impersonationUser } = useSelector((state) => state.impersonationUser);
  const [activeUser, setActiveUser] = useState({});
  const [isLoading, setIsLoading] = useState(true);
  const notyf = useContext(NotyfContext);
  const { faviconUrl } = useWhitelabel();

  useEffect(() => {
    setActiveUser(impersonationUser.id ? impersonationUser : user);
  }, [user, impersonationUser]);

  useEffect(() => {
    const fetchUsers = async () => {
      await dispatch(getSubaccounts())
        .catch((error) => {
          notyf.open({
            type: "danger",
            message: error,
            duration: 5000,
            dismissible: false,
            ripple: true,
            position: {
              x: "center",
              y: "top",
            },
          });
        })
        .finally(() => {
          setTimeout(() => {
            setIsLoading(false);
          }, [500]);
        });
    };

    if (activeUser.id) {
      fetchUsers();
    }
  }, [dispatch, activeUser]);

  return (
    <React.Fragment>
      <Helmet title="Subaccounts">
        <link rel="icon" href={faviconUrl} />
      </Helmet>
      <Container fluid className="p-0 w-100 h-100">
        <Clients
          title="Subaccounts"
          clientList={subaccounts}
          isLoading={isLoading}
        />
      </Container>
    </React.Fragment>
  );
};

export default Subaccounts;
